import React, { memo } from 'react';
import css from './ShippingDetailsForm.module.css';

import { FieldRadioButton } from '../../../components';
import { required } from '../../../util/validators';
import { OWN, PLATFORM, SHIPPING_PREFERENCE } from '../../../util/constants';

const preferenceOptions = [
  { key: PLATFORM, labelId: 'ShippingDetailsForm.platform' },
  { key: OWN, labelId: 'ShippingDetailsForm.own' },
];

const DeliveryOptions = ({ form, intl, onVerifyShippingPreferences }) => (
  <div className={css.shippingOptions}>
    {preferenceOptions.map(({ key, labelId }) => (
      <FieldRadioButton
        key={key}
        id={`shippingPreference.${key}`}
        name={SHIPPING_PREFERENCE}
        label={intl.formatMessage({ id: labelId })}
        value={key}
        onChange={e => {
          form.batch(() => {
            form.change(SHIPPING_PREFERENCE, e.target.value);
          });
          onVerifyShippingPreferences(e.target.value);
        }}
        validate={required(
          intl.formatMessage({
            id: 'ShippingDetailsForm.shippingPreferenceRequired',
          })
        )}
      />
    ))}
  </div>
);

export default memo(DeliveryOptions);
